import { createTheme, createVariant, globalTheme } from '@clds/component-theme';

export const colorPickerTheme = createTheme({
  item: {
    borderColor: globalTheme.palette.secondaryAlt,
    sizeVariant: {
      xs: {
        width: '1.188rem',
        height: '1.188rem',
      },
      sm: {
        width: '1.75rem',
        height: '1.75rem',
      },
      md: {
        width: '2.5rem',
        height: '2.5rem',
      },
    },
  },
  field: {
    sizeVariant: {
      xs: {
        addIcon: 'lg',
        checkIcon: 'sm',
        textField: 'sm',
      },
      sm: {
        addIcon: 'xl',
        checkIcon: 'md',
        textField: 'sm',
      },
      md: {
        addIcon: 'xxl',
        checkIcon: 'lg',
        textField: 'md',
      },
    },
  },
  palette: {
    itemSpacing: globalTheme.spacing.xxs,
    addIconSpacing: globalTheme.spacing.xxs,
  },
});

export const colorPickerSizeVariant = createVariant(({ size }) => colorPickerTheme.item.sizeVariant[size]);
